import React from "react"
//import LandingPage from "../components/LandingPage"
import LandingPage from "../components/Home"

const ErrorHistoryScreen = props => {
  return <LandingPage  />
}

export default ErrorHistoryScreen
